// extracted by mini-css-extract-plugin
module.exports = {"section1Container":"Section1_section1Container__p6n4_","itemContainer":"Section1_itemContainer__mGK7K","itemRow":"Section1_itemRow__w11u1","item":"Section1_item__CD99a"};